// extracted by mini-css-extract-plugin
module.exports = {"bmInput":"FormInput_bmInput__3CRzz","form-control-sm":"FormInput_form-control-sm__1G7Po","form-control-lg":"FormInput_form-control-lg__5xebw"};